import { IJsonQueryResponse } from '@cian/api-models/monolith-python/cian-api/site/v1/get-json-query';
import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';
import {
  fetchGetNewbuildingJsonQuery,
  IGetNewbuildingJsonQueryResponse200,
  IGetNewbuildingJsonQueryResponse400,
  TGetNewbuildingJsonQueryResponse,
} from '../../repositories/newbuilding-search/v2/get-newbuilding-json-query';
import { NotFoundError } from '@cian/peperrors/shared';

export async function resolveNewbuildingJsonQuery(
  subdomain: string,
  path: string,
  logger: ILogger,
  httpApi: IHttpApi,
): Promise<TGetNewbuildingJsonQueryResponse | IJsonQueryResponse> {
  try {
    const getJsonQueryResponse = await fetchGetNewbuildingJsonQuery<
      IGetNewbuildingJsonQueryResponse200,
      IGetNewbuildingJsonQueryResponse400
    >({ httpApi, parameters: { subdomain, path } });
    if (getJsonQueryResponse.statusCode === 200 && getJsonQueryResponse.response.jsonQuery) {
      return getJsonQueryResponse.response;
    }

    throw new NotFoundError({
      domain: 'src/shared/api/jsonQuery/getNewbuildingJsonQuery',
      message: 'JsonQuery response error',
    });
  } catch (err) {
    logger.error(err, {
      message: err.message,
      stack: err.stack,
      comment: 'Error in resolveNewbuildingJsonQuery',
    });

    throw err;
  }
}
